module.exports = __webpack_public_path__ + "img/isfp.56ef6452.png";